import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  HotelPurchaseModel,
  HotelPurchaseMutationInput,
  HotelPurchaseDeleteInput,
  HotelPurchaseUpdateInput,
} from './model';

export function useCreateHotelPurchase(
  options?: UseMutationOptions<
    ApiResult<HotelPurchaseModel>,
    ApiError,
    HotelPurchaseMutationInput
  >,
): UseMutationResult<
  ApiResult<HotelPurchaseModel>,
  ApiError,
  HotelPurchaseMutationInput
> {
  return useMutation<
    ApiResult<HotelPurchaseModel>,
    ApiError,
    HotelPurchaseMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'hotel-purchases',
      method: 'POST',
      classType: HotelPurchaseModel,
      body,
    });
  }, options);
}

export function useUpdateHotelPurchase(
  options?: UseMutationOptions<
    ApiResult<HotelPurchaseModel>,
    ApiError,
    HotelPurchaseUpdateInput
  >,
): UseMutationResult<
  ApiResult<HotelPurchaseModel>,
  ApiError,
  HotelPurchaseUpdateInput
> {
  return useMutation<
    ApiResult<HotelPurchaseModel>,
    ApiError,
    HotelPurchaseUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `hotel-purchases/${body.hotelPurchaseId}`,
      method: 'PUT',
      classType: HotelPurchaseModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteHotelPurchase(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    HotelPurchaseDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, HotelPurchaseDeleteInput> {
  return useMutation<{ message: string }, ApiError, HotelPurchaseDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `hotel-purchases/${body.hotelPurchaseId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}

export function useVoidHotelPurchase(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    HotelPurchaseDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, HotelPurchaseDeleteInput> {
  return useMutation<{ message: string }, ApiError, HotelPurchaseDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `hotel-purchases/${body.hotelPurchaseId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
